import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { JOBS_PORTAL_URL } from '../../Services/courseService';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import './JobList.css';

function JobList() {
  const [jobs, setJobs] = useState([]);
  const [showProfileForm, setShowProfileForm] = useState(false);
  const [showProfileChoice, setShowProfileChoice] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState({
    studentsName: '',
    phoneNumber: '',
    maritalStatus: '',
    gender: '',
    schoolingLevel: '',
    graduationLevel: '',
    disabilityStatus: '',
  });
  const [appliedJobIds, setAppliedJobIds] = useState([]);
  const [jobApplied, setJobApplied] = useState(false);

  const API_URL = `${JOBS_PORTAL_URL}/api`;
  useEffect(() => {
    const fetchJobsAndApplications = async () => {
      setIsLoading(true);
      try {
        const [jobsRes, appsRes] = await Promise.all([
          axios.get(`${API_URL}/jobs?status=APPROVE`),
          axios.get(`${API_URL}/registrations/student/${localStorage.getItem('userId')}`)
        ]);

        const appliedIds = appsRes.data.map(app => app.jobId);
        setAppliedJobIds(appliedIds);
        setJobs(jobsRes.data);
      }
      catch (e) {

      } finally {
        setIsLoading(false);
      }
    };

    fetchJobsAndApplications();
  }, [jobApplied, API_URL]);

  // useEffect(() => {
  //   const fetchJobs = async () => {
  //     setIsLoading(true);
  //     try {
  //       const res = await axios.get(`${API_URL}/jobs?status=APPROVE`);
  //       setJobs(res.data);
  //     } catch {
  //       toast.error('Error fetching jobs');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchJobs();
  // }, []);

  const checkProfileStatus = async (studentId) => {
    const response = await axios.get(`${API_URL}/registrations/${studentId}/profile-status`);
    return response.data.hasProfile;
  };

  const handleRegister = async (jobId) => {
    toast.dismiss();
    const studentId = localStorage.getItem('userId');
    if (!studentId) {
      toast.error("Please login to apply for jobs.");
      return;
    }

    try {
      const hasProfile = await checkProfileStatus(studentId);

      if (hasProfile) {
        setSelectedJobId(jobId);
        setShowProfileChoice(true);
      } else {
        setSelectedJobId(jobId);
        setShowProfileForm(true);
      }
    } catch {
      toast.dismiss();
      toast.error("Error checking profile status");
    }
  };


  const submitRegistration = async (jobId, studentId) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('studentId', studentId);
      formData.append('jobId', jobId);

      Object.entries(profileData).forEach(([key, value]) => {
        if (value) formData.append(key, value);
      });

      if (resumeFile) {
        formData.append('resume', resumeFile);
      }

      const response = await axios.post(`${API_URL}/registrations`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success(response.data);

      setJobApplied(prev => !prev);
      

    } catch (err) {
      const msg = err.response?.data || "Error applying for job";
      toast.error(msg.message || msg);
    } finally {
      setIsLoading(false);

      handleCloseForm();
    }
  };



  const handleProfileChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      let formattedValue = value;

      if (value.startsWith('+')) {
        formattedValue = '+' + value.slice(1).replace(/\D/g, '').slice(0, 11);
      } else {
        formattedValue = value.replace(/\D/g, '').slice(0, 12);
      }

      setProfileData(prev => ({ ...prev, [name]: formattedValue }));
    } else {
      setProfileData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleFormSubmit = () => {
    const studentId = localStorage.getItem('userId');
    if (!studentId || !selectedJobId) return;
    toast.dismiss();

    const requiredFields = [
      'studentsName',
      'phoneNumber',
      'maritalStatus',
      'gender',
      'schoolingLevel',
      'graduationLevel',
      'disabilityStatus'
    ];

    const missingFields = requiredFields.filter(field => !profileData[field]);
    if (missingFields.length > 0) {
      toast.error("Please fill all the required profile fields.");
      return;
    }

    if (!resumeFile) {
      toast.error("Please upload your resume to proceed.");
      return;
    }

    submitRegistration(selectedJobId, studentId);
  };

  const handleCloseForm = () => {

    setIsLoading(false);
    setShowProfileForm(false);
    setShowProfileChoice(false);
    setProfileData({
      studentsName: '',
      phoneNumber: '',
      maritalStatus: '',
      gender: '',
      schoolingLevel: '',
      graduationLevel: '',
      disabilityStatus: '',

    });
    setResumeFile(null);
    setSelectedJobId(null);
  };

  const visibleJobs = jobs.filter(job => !appliedJobIds.includes(job.id));

  return (
    <div className="job-ui-container">
      <h2 className="job-title">Explore Job Openings</h2>
      <div className="job-ui-grid">
        {visibleJobs?.length > 0 ? (
          visibleJobs?.map(job => (
            <div className="job-ui-card" key={job.id}>
              <div className="job-ui-header">
                <div className="job-ui-company-logo">🏢</div>
                <div>
                  <h3>{job.title}</h3>
                  <p>{job.company}</p>
                </div>
              </div>
              <p className="job-ui-description">{job.description}</p>
              <div className="job-ui-meta">
                <span>📍 {job.location}</span>
                <span>📄 {job.type}</span>
                <span>👥 Openings: {job.no_of_openings}</span>
                <span>💰 Annual CTC: {job.ctc ? `₹${job.ctc}` : 'Not mentioned'}</span>
              </div>
              <button className="job-ui-btn" onClick={() => handleRegister(job.id)}>Apply Now</button>
            </div>
          ))
        ) : (
          <div className="no-jobs-message">
            <h3>There are currently no job opportunities listed. Please check back later.</h3>
          </div>
        )}
      </div>

      {showProfileChoice && (
        <div className="job-ui-modal">
          <div className="job-ui-form-container">
            <h3 className="job-ui-form-title">Apply with Existing Profile?</h3>
            <p>You have already provided your profile and resume. Would you like to update your details or apply using the existing information?</p>
            <div className="job-ui-form-actions">
              <button
                className="job-ui-btn"
                onClick={() => {
                  setShowProfileChoice(false);
                  setShowProfileForm(true);
                }}
              >
                Update Details
              </button>
              <button
                className="job-ui-btn"
                onClick={async () => {
                  const studentId = localStorage.getItem('userId');
                  setShowProfileChoice(false);
                  if (selectedJobId && studentId) {
                    await submitRegistration(selectedJobId, studentId);
                  }
                }}
              >
                Submit Application
              </button>
              <button
                className="job-ui-btn job-ui-btn-cancel"
                onClick={() => setShowProfileChoice(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showProfileForm && (
        <div className="job-ui-modal">
          <div className="job-ui-form-container">
            <h3 className="job-ui-form-title">Complete Your Profile</h3>

            <div className="job-ui-form-grid">
              <input name="studentsName" placeholder="Student Name" onChange={handleProfileChange} />
              <input
                name="phoneNumber"
                placeholder="Phone Number with country code"
                value={profileData.phoneNumber || ""}
                onChange={handleProfileChange}
                maxLength="12"
                inputMode="numeric"
                autoComplete="off"
              />


              <select name="maritalStatus" onChange={handleProfileChange}>
                <option value="">Marital Status</option>
                <option value="SINGLE">Single</option>
                <option value="MARRIED">Married</option>
                <option value="DIVORCED">Divorced</option>
                <option value="WIDOWED">Widowed</option>
                <option value="SEPARATED">Separated</option>
                <option value="OTHER">Other</option>
              </select>

              <select name="gender" onChange={handleProfileChange}>
                <option value="">Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
                <option value="TRANSGENDER">Transgender</option>
                <option value="NON_BINARY">Non-Binary</option>
                <option value="OTHER">Other</option>
                <option value="PREFER_NOT_TO_SAY">Prefer not to say</option>
              </select>

              <select name="schoolingLevel" onChange={handleProfileChange}>
                <option value="">Select Schooling Level</option>
                <option value="HIGH_SCHOOL">High School</option>
                <option value="UNDERGRADUATE">Undergraduate </option>
                <option value="OTHER">Other</option>

              </select>

              <select name="graduationLevel" onChange={handleProfileChange}>
                <option value="">Select Graduation Level</option>
                <option value="DIPLOMA">Diploma</option>
                <option value="BACHELORS">Bachelors</option>
                <option value="MASTERS">Masters</option>
                <option value="DOCTORATE">Doctorate</option>
                <option value="OTHER">Other</option>
              </select>

              <select name="disabilityStatus" onChange={handleProfileChange}>
                <option value="">Disability Status</option>
                <option value="NONE">None</option>
                <option value="PHYSICAL">Physical</option>
                <option value="VISUAL">Visual</option>
                <option value="HEARING">Hearing</option>
                <option value="MENTAL">Mental</option>
                <option value="MULTIPLE">Multiple</option>
                <option value="OTHER">Other</option>
              </select>


              <input type="file" accept=".pdf,.doc,.docx" onChange={(e) => setResumeFile(e.target.files[0])} />
            </div>


            {resumeFile && <p className="job-ui-resume-label">📎 {resumeFile.name}</p>}

            <div className="job-ui-form-actions">
              <button
                className="job-ui-btn"
                onClick={handleFormSubmit}
                disabled={isLoading}
              >
                {isLoading ? <ClipLoader size={20} color="#fff" /> : 'Submit & Apply'}
              </button>
              <button className="job-ui-btn job-ui-btn-cancel" onClick={handleCloseForm} disabled={isLoading}>
                Cancel
              </button>
            </div>


          </div>


        </div>
      )}

      {isLoading && (
        <div className="job-ui-loader-overlay">
          <ClipLoader size={35} color="#fff" />
          {/* <p style={{ color: '#fff', marginTop: '10px' }}>please wait</p> */}
        </div>
      )}

    </div>
  );
}

export default JobList;
